// src/components/skins/dashboard-pv.js
export class DashboardPvHtml {
  pvskin() {
    return `
      <div class="container-layout d-grid grid-2 dashboard-pv-v2">
        <!-- PV Summary Data -->
        <div class="container-column dashboard-panel dashboard-chart-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <span class="iconify" data-icon="mingcute:sun-line"></span>
              <h3>PV Summary Data</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
                <button class="chip active" data-chart-control="pv-summary-tab" data-tab="core">Core</button>
                <button class="chip" data-chart-control="pv-summary-tab" data-tab="kpi">KPI</button>
            </div>
          </div>
          <div class="container-body dashboard-v2-list dashboard-v2-controls-list pv-summary-list" data-pv-summary-list>
            <div data-pv-summary-item data-tab="core"><span>Total Power Output (MW)</span><strong data-register="pvactivepower">0.00</strong></div>
            <div data-pv-summary-item data-tab="core"><span>Daily Energy Generation (MWh)</span><strong data-register="pvdailyenergy">0.00</strong></div>
            <div data-pv-summary-item data-tab="core"><span>Total Energy Generation (MWh)</span><strong data-register="pvtotalenergy">0.00</strong></div>
            <div data-pv-summary-item data-tab="core"><span>PV Active Alarms (#)</span><strong data-register="pvalarms">0</strong></div>
            <div data-pv-summary-item data-tab="core"><span>Avg. DC Capacity (%)</span><strong data-register="dccapacity">0.00</strong></div>
            <div data-pv-summary-item data-tab="core"><span>Avg. AC Capacity (%)</span><strong data-register="accapacity">0.00</strong></div>
            <div data-pv-summary-item data-tab="core"><span>Avg. Frequency (%)</span><strong data-register="pvefficiency">0.00</strong></div>

            <div data-pv-summary-item data-tab="kpi"><span>Installed Capacity (kWp)</span><strong data-register="installedcapacity">N/A</strong></div>
            <div data-pv-summary-item data-tab="kpi"><span>Inverter Availability (%)</span><strong data-register="inverteravailability">N/A</strong></div>
            <div data-pv-summary-item data-tab="kpi"><span>Performance Ratio (%)</span><strong data-register="performanceratio">N/A</strong></div>
            <div data-pv-summary-item data-tab="kpi"><span>Specific Yield (kWh/kWp)</span><strong data-register="specificyield">N/A</strong></div>
            <div data-pv-summary-item data-tab="kpi"><span>Total AC Power (kW)</span><strong data-register="totalacpower">N/A</strong></div>
            <div data-pv-summary-item data-tab="kpi"><span>Curtailment (%)</span><strong data-register="curtailment">N/A</strong></div>
            <div data-pv-summary-item data-tab="kpi"><span>Irradiance (W/m²)</span><strong data-register="irradiance">N/A</strong></div>
            <div data-pv-summary-item data-tab="kpi"><span>Module Temperature (°C)</span><strong data-register="moduletemperaturekpi">N/A</strong></div>
          </div>
        </div>

        <!-- CABIN SUMMARY DATA -->
        <div class="container-column dashboard-panel dashboard-chart-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <h3>CABIN SUMMARY DATA</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
                <button class="full-screen-button dashboard-v2-fullscreen-btn chip" title="Full Screen">
                  <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                </button>
            </div>
          </div>
          <div class="container-body">
            <div class="table-responsive">
              <table class="has-min-width">
                <thead>
                  <tr>
                    <th>CABIN</th>
                    <th>MODE</th>
                    <th>MWh (TOTAL)</th>
                    <th>MWh (DAY)</th>
                    <th>kW (AC)</th>
                    <th>V (AC)</th>
                    <th>A (AC)</th>
                    <th>kW (DC)</th>
                    <th>V (DC)</th>
                    <th>A (DC)</th>
                    <th>°C</th>
                  </tr>
                </thead>
                <tbody class="cabinBody">
                  <!-- Filled dynamically by JS -->
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- REMOTE MONITORING (Dynamic PV Columns) -->
        <div class="container-column dashboard-panel dashboard-chart-card remote-control">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <span class="iconify" data-icon="mingcute:remote-control-line"></span>
              <h3>Remote Monitoring</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
                <button class="full-screen-button dashboard-v2-fullscreen-btn chip" title="Full Screen">
                  <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                </button>
            </div>
          </div>
          <div class="container-body">
            <div class="table-responsive">
              <table class="has-min-width">
                <thead>
                  <tr>
                    <th colspan="2"></th>
                    <!-- PV columns injected by JS -->
                  </tr>
                </thead>
                <tbody>
                  <!-- Rows injected by JS -->
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- PV Power Comparison -->
        <div class="container-column dashboard-panel dashboard-chart-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <h3>PV Power Comparison</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
              <button class="chip active" data-chart-control="preset" data-chart-id="pv_power_comparison" data-preset="power">Power</button>
              <button class="chip" data-chart-control="preset" data-chart-id="pv_power_comparison" data-preset="energy">Energy</button>
              <select class="chip" data-chart-control="type" data-chart-id="pv_power_comparison">
                <option value="lines">Line</option>
                <option value="lines+markers">Line + Markers</option>
                <option value="bar">Bar</option>
                <option value="area">Area</option>
                <option value="spline">Spline</option>
              </select>
              <button class="full-screen-button dashboard-v2-fullscreen-btn chip" title="Full Screen">
                <span class="iconify" data-icon="mdi:fullscreen" style="font-size:14px;pointer-events:none;"></span>
              </button>
            </div>
          </div>
          <div class="container-body">
            <div class="column-chart" id="pv_power_comparison"></div>
          </div>
        </div>

        <!-- PV Specific Power Comparison -->
        <div class="container-column dashboard-panel dashboard-chart-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <h3>Inverter Specific Power Comparison</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
              <select class="chip" data-chart-control="type" data-chart-id="pv_specific_power_comparison">
                <option value="lines">Line</option>
                <option value="lines+markers">Line + Markers</option>
                <option value="bar">Bar</option>
                <option value="area">Area</option>
                <option value="spline">Spline</option>
              </select>
              <button class="full-screen-button dashboard-v2-fullscreen-btn chip" title="Full Screen">
                <span class="iconify" data-icon="mdi:fullscreen" style="font-size:14px;pointer-events:none;"></span>
              </button>
            </div>
          </div>
          <div class="container-body">
            <div class="column-chart" id="pv_specific_power_comparison"></div>
          </div>
        </div>

        <!-- PV Availability Comparison -->
        <div class="container-column dashboard-panel dashboard-chart-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <h3>PV Availability Comparison</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
              <select class="chip" data-chart-control="type" data-chart-id="pv_availability_comparison">
                <option value="lines">Line</option>
                <option value="lines+markers">Line + Markers</option>
                <option value="bar">Bar</option>
                <option value="area">Area</option>
                <option value="spline">Spline</option>
              </select>
              <button class="full-screen-button dashboard-v2-fullscreen-btn chip" title="Full Screen">
                <span class="iconify" data-icon="mdi:fullscreen" style="font-size:14px;pointer-events:none;"></span>
              </button>
            </div>
          </div>
          <div class="container-body">
            <div class="column-chart" id="pv_availability_comparison"></div>
          </div>
        </div>

        <!-- Module Temperature Comparison -->
        <div class="container-column dashboard-panel dashboard-chart-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <h3>Module Temperature Comparison</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
              <select class="chip" data-chart-control="type" data-chart-id="module_temp_comparison">
                <option value="lines">Line</option>
                <option value="lines+markers">Line + Markers</option>
                <option value="bar">Bar</option>
                <option value="area">Area</option>
                <option value="spline">Spline</option>
              </select>
              <button class="full-screen-button dashboard-v2-fullscreen-btn chip" title="Full Screen">
                <span class="iconify" data-icon="mdi:fullscreen" style="font-size:14px;pointer-events:none;"></span>
              </button>
            </div>
          </div>
          <div class="container-body">
            <div class="column-chart" id="module_temp_comparison"></div>
          </div>
        </div>

        <div class="container-column dashboard-panel dashboard-chart-card pv-alarms-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <span class="iconify" data-icon="mdi:alarm-light-outline"></span>
              <h3>PV Alarms</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
              <button class="chip" data-action="view-pv-alarms">View All Alarms</button>
            </div>
          </div>
          <div class="container-body pv-alarms-body">
            <div class="pv-alarms-table-wrap">
              <table class="pv-alarms-table">
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Severity</th>
                    <th>Message</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody data-pv-alarms-body>
                  <tr>
                    <td colspan="4" class="pv-alarms-empty">No active PV alarms</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}